import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Field, change, formValueSelector} from 'redux-form';
import {InputField} from '../../../../common/components/form';
import {toFloat} from '../../../../common/util/fieldsNormalization';
import {Card, Grid} from 'semantic-ui-react';
import {MASTER_VEHICLE_FORM} from '../../../../common/forms';
import {chargeCapacityFit} from '../../../utils';
import './editProductData.scss';
import References from './references';

class ServiceData extends Component {
  constructor(props) {
    super(props);
    this.updateTonnage = this.updateTonnage.bind(this);
  }

  getValueForDescription(value) {
    if (!value || value === ' null' || value === 'NO APLICA' || value === 'NO') {
      return '';
    }
    return ` ${value}`;
  }
  
  updateTonnage(field, value) { // eslint-disable-line
    const {chargeCapacity} = this.props;
    const chargeValue = this.getValueForDescription(field === 'chargeCapacity' ? ` ${value}` : ` ${chargeCapacity}`);
    const tonnageValue = `${chargeCapacityFit(chargeValue)}`;
    this.props.change('masterVehicle', 'tonnage', tonnageValue);
  }

  render() {
    const {addService, handleChangeImages, description} = this.props;
    return (
      <div>
        <Card raised fluid className='vehicle-master-form'>
          <Grid textAlign='left'>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Descripción Sri</h4>
              </Grid.Column>
              <Grid.Column width={10}>
                <h4>{description} </h4>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Peso Vacío (Kg)</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='weight'
                  component={InputField}
                  type='Number'
                  normalize={toFloat}
                  min="0.00" step="0.01" pattern='^\d+(?:\.\d{1,2})?$'
                  disabled={!addService}
                  invalidMessage='Por favor, llene este campo siguiendo el formato 0.00 y el valor mínimo debe ser 0.01'
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Capacidad Carga (Kg)</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='chargeCapacity'
                  component={InputField}
                  type='Number'
                  normalize={(value) => {
                    this.updateTonnage('chargeCapacity', value);
                    return toFloat(value);
                  } }
                  min="0.00" step="0.01" pattern='^\d+(?:\.\d{1,2})?$'
                  disabled={!addService}
                  invalidMessage='Por favor, llene este campo siguiendo el formato 0.00 y el valor mínimo debe ser 0.01'
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Certificado Único de Homologación Vehícular</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='cuhv'
                  type='text'
                  uppercase
                  maxLength={30}
                  component={InputField}
                  disabled={!addService}
                  required
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>
                <h4>Peso Bruto (Kg)</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='wholeWeight'
                  component={InputField}
                  type='Number'
                  normalize={toFloat}
                  min="0.00" step="0.01" pattern='^\d+(?:\.\d{1,2})?$'
                  disabled={!addService}
                  invalidMessage='Por favor, llene este campo siguiendo el formato 0.00 y el valor mínimo debe ser 0.01'
                  required
                />
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Tonelage (Toneladas)</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Field
                  name='tonnage'
                  component={InputField}
                  type='text'
                  normalize={toFloat}
                  min="0.0000" step="0.0001" pattern='^\d+(?:\.\d{1,4})?$'
                  disabled={!addService}
                  invalidMessage='Por favor, llene este campo siguiendo el formato 0.00 y el valor mínimo debe ser 0.01'
                  required
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <h4>Archivos de Homologación:</h4>
          <References {...this.props} addService={addService} handleChangeImages={handleChangeImages}/>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const formValues = formValueSelector(MASTER_VEHICLE_FORM.name);
  const weight = formValues(state, 'weight');
  const chargeCapacity = formValues(state, 'chargeCapacity');
  const tonnage = formValues(state, 'tonnage');
  const wholeWeight = formValues(state, 'wholeWeight');
  const description = formValues(state, 'description');
  return {
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    weight,
    chargeCapacity,
    tonnage,
    wholeWeight,
    description,
    // 'vehiclesModelsList': state.vehiclesModels.vehicles,
  };
};

export default connect(mapStateToProps, {change})(ServiceData);
